export enum EnumRoles {
    user = 1,
    admin = 2,
    moderator = 3
}